<div class="container">
  <mat-card class="example-card">
    <mat-card-header>
      <div
        mat-card-avatar
        class="example-header-image"
      ></div>
      <mat-card-title>We're sorry, upgrading is temporarily not supported.</mat-card-title>
      <!-- <mat-card-subtitle>Unlock all features for only $4.99.</mat-card-subtitle> -->
    </mat-card-header>
    <!-- <img
      mat-card-image
      [src]="imagePath"
      alt="stocks photo"
    >
    <mat-card-content>
      <ul>
        <li>Get updates every minute.</li>
        <li>Save an unlimited number of favorite filings.</li>
        <li>Get access to all filters and settings.</li>
        <li>Get sound alerts.</li>
      </ul>
    </mat-card-content>
    <mat-card-actions>
      <button
        mat-button
        (click)="handlePayment()"
      >UPGRADE</button>
    </mat-card-actions> -->
  </mat-card>
</div>
